import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/nameInput/languageSelection/styles.scss';export default {
  "languageSelection": "_languageSelection_b144d_1",
  "group": "_group_b144d_10",
  "selectedInput": "_selectedInput_b144d_18",
  "input": "_input_b144d_26",
  "language": "_language_b144d_1"
};